export default __webpack_public_path__ + "static/media/Tunic of the Wells of Night.d7fd9e65.jpg";